import {Component, OnInit, ViewChild} from '@angular/core';
import {DefaultApi} from '../service/default.api';
import {Provider} from '../model/Provider';
import {Subscription} from 'rxjs';
import {EnterEmailComponent} from '../enter-email/enter-email.component';
import {Router} from '@angular/router';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ReCaptchaV3Service} from 'ng-recaptcha-2';

@Component({
    selector: 'app-plugin-list',
    templateUrl: './plugin-list.component.html',
    standalone: false
})
export class PluginListComponent implements OnInit {
  private providers: Provider[];
  private captchaResponse;
  public loginForm;
  public loading = false;
  public error = '';
  credentials = {username: '', textMessage: '', captcha: ''};
  private subscription: Subscription;
  // @ViewChild(RecaptchaComponent, {static: false}) captcha: RecaptchaComponent;

  constructor(private api: DefaultApi, private recaptchaV3Service: ReCaptchaV3Service,
              private dialog: MatDialog, private _snackBar: MatSnackBar, private router: Router) {

  }

  ngOnInit() {
    this.api.getProviders().subscribe((value: Provider[]) => this.providers = value);
  }

  getProviders(){
    return this.providers;
  }

  handleCorrectCaptcha(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
  }

  onSubmit(): void {
    this.subscription = this.recaptchaV3Service.execute('signin').subscribe(value => {
        this.credentials.captcha = value;
        console.log(this.credentials);
        this.loading = true;
        this.api.login(this.credentials).subscribe(
            (response) => {
              this.loading = false;
              this.error = '';
              this.api.initSession().subscribe(() => {
                window.location.href = `/portals/`;
              });
            },
            (response) => {
              this.loading = false;
              this.error = response.statusText;
              console.log('!!!!!!!!!!!!!!!!!! ' + response.headers.get('error'));
              this._snackBar.open(response.headers.get('error'), 'Dismiss', {
                duration: 4000,
              });
            }
          );
      });

  }

  btnSocialLoginClick(providerLink) {
    /*this.api.socialLogin(providerLink).subscribe(
      (response) => {
        let url = window.URL.createObjectURL(response);
        window.location.href = url;
      }
    )*/
    window.location.href = 'http://localhost:8080/auth/socialLogin/facebook/';
  }


  forgotPasswordClick(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'custom-dialog-container';

    const dialogRef = this.dialog.open(EnterEmailComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => {
        if (data) {
          this.api.getRecoverPasswordLink(data).subscribe(() => {
            this._snackBar.open('We sent email with instructions to your email', 'Dismiss', {
              duration: 4000,
            });
          });
        }
      }
    );
  }
}
